import { alpha, styled } from '@mui/material';
import { FONT_MONO } from 'themes/tokens';

export const FolderItemGrid = styled('div', {
  shouldForwardProp: (prop) => prop !== 'minTile',
})<{ minTile?: number }>(({ theme, minTile = 220 }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: `repeat(auto-fill, minmax(${minTile}px, 1fr))`,
}));

export const FolderCard = styled('button', {
  shouldForwardProp: (prop) => prop !== 'minHeight',
})<{ minHeight?: number }>(({ theme, minHeight = 184 }) => ({
  minHeight,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2.5),
  borderRadius: '14px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
  font: 'inherit',
  cursor: 'pointer',
  transition: theme.transitions.create(['transform', 'border-color', 'box-shadow', 'background-color']),
  '& .folder-icon': { color: theme.palette.accent.main, display: 'grid', placeItems: 'center' },
  '&:hover': {
    borderColor: theme.palette.accent.main,
    transform: 'translateY(-2px)',
    backgroundColor: alpha(theme.palette.accent.main, 0.06),
    boxShadow: `0 12px 30px -14px ${alpha(theme.palette.accent.main, 0.55)}`,
  },
}));

export const FolderCardName = styled('span')(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 700,
  color: theme.palette.text.primary,
  textAlign: 'center',
  wordBreak: 'break-word',
}));

export const FolderCardCount = styled('span')(({ theme }) => ({
  fontFamily: FONT_MONO,
  fontSize: '0.72rem',
  color: theme.palette.text.secondary,
}));

export const Breadcrumb = styled('nav')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
  fontSize: '0.85rem',
}));

export const BreadcrumbButton = styled('button')(({ theme }) => ({
  border: 'none',
  background: 'none',
  padding: theme.spacing(0.25, 0.5),
  borderRadius: 6,
  font: 'inherit',
  fontSize: '0.85rem',
  fontWeight: 600,
  cursor: 'pointer',
  color: theme.palette.text.secondary,
  transition: theme.transitions.create('color'),
  '&:hover': { color: theme.palette.accent.main },
  '&:disabled': { cursor: 'default', color: theme.palette.text.primary },
}));

export const BreadcrumbSep = styled('span')(({ theme }) => ({
  color: theme.palette.text.disabled,
}));
